import { TSessionDetails } from '@api/io/session.io';
import { isProjectSelection } from '@fe-learner-common/api/schemas/sessionsSchema';

type TSelectionProgress = {
  projectType?: TSessionDetails['projectType'];
  selfEnrollmentProgress?: TSessionDetails['selfEnrollmentProgress'];
};

export const isCompletedProjectSelection = (
  session?: TSelectionProgress,
): boolean =>
  isProjectSelection(session) &&
  session?.selfEnrollmentProgress === 'completed';
